var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list" }, [
    _c("div", { staticClass: "list" }, [
      _c(
        "div",
        _vm._l(_vm.list, function(item, index) {
          return _c("div", [
            _c("div", { staticClass: "media media-2 media-3" }, [
              _c("a", { attrs: { href: "/news/topic/" + item.id } }, [
                _c("div", {
                  staticClass: "media-left",
                  style:
                    "background: url(" +
                    item.img_url[0] +
                    ") center no-repeat; background-size: cover;"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "media-body elip" }, [
                  _vm._v(_vm._s(item.title))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "media" }, [
              _c(
                "ul",
                _vm._l(item.childs, function(relation, i) {
                  return _c("a", { attrs: { href: "/news/" + relation.id } }, [
                    _c("li", [
                      _vm._v(_vm._s(relation.title)),
                      _c("span", [
                        _vm._v(_vm._s(_vm.friendlyTime(relation.released_at)))
                      ])
                    ])
                  ])
                })
              )
            ])
          ])
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2f4386c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4386c3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-list/img-list.vue
// module id = null
// module chunks = 